import { getPreviousYears, monthYear } from '../../../../../../utils/constants/date_month'
import { CRUD } from '../../../../../../utils/enums'
import { InputModel } from '../../../../../../utils/types'
import { Item } from '../../../../../../utils/types/generals'
import { TemplateType } from '../../enums'
import { InitialData, ModelOption } from './types'

export const initialFilterValues = {
  role: '',
  status: '',
  search: '',
}

export const formatFilterMainOption = {
  search: 'search',
  from: 'date_init',
  to: "date_end",
  createYear: "year",
  month: "month",
}

export const initialValues = {
  title: {
    label: 'optionGroup.tags.title.optionName',
    translate: true,
    name: 'title',
    type: 'text',
    value: null,
    rest: {
      placeholder: 'Ingrese el nombre del grupo de opciones'
    },
    validate: {
      required: true,
    },
    size: {
      xl: 8,
      lg: 8,
      md: 12,
      sm: 12,
      xs: 12
    },
  },
  template: {
    label: 'optionGroup.tags.title.templateType',
    translate: true,
    name: 'template',
    type: 'select',
    items: [],
    value: null,
    /* validate: {
      required: true,
    }, */
    rest: {
      placeholder: 'Tipo de plantilla'
    },
    size: {
      xl: 4,
      lg: 4,
      md: 12,
      sm: 12,
      xs: 12
    },
  },
} as { [x: string]: InputModel }

export const modelOption: ModelOption = { id: 1, description: null, iconUrl: null }

export const initialData: InitialData = {
  title: null,
  template: TemplateType.DEFAULT,
  //options: [modelOption, { ...modelOption, id: 2 }],
  //optionId: 2,
}

export const initialTable = {
  column: [],
  row: [],
}

export const gender = [
  {
    value: '1',
    label: 'Masculino',
  },
  {
    value: '0',
    label: 'Femenino',
  },
]

export const username = [
  {
    value: '1',
    label: 'Teléfono',
  },
  {
    value: '0',
    label: 'Correo electrónico',
  },
]

export const useMenuItems = (styles: any) => [
  {
    value: CRUD.EDIT,
    label: 'Editar compañía',
    // icon: <Icon sx={styles.menuIcons}>{icons('edit')}</Icon>,
  },
]

export const accept = ['png', 'jpg', 'jpeg']

export interface ItemsInput {
  status?: Item[]
  actionPlanType?: Item[]
  search?: string
}

export const input = {
  search: {
    label: 'general.search',
    translate: true,
    name: 'search',
    type: 'text',
    value: null,
  },
  createYear: {
    label: 'general.filterDate.year',
    translate: true,
    name: 'createYear',
    type: 'filter-select',
    items: getPreviousYears().map((e) => ({
      label: e?.label,
      value: e?.value,
    })),
    value: null,
    size: {
      xl: 6,
      lg: 6,
      md: 6,
      sm: 6,
      xs: 6,
    },
  },
  month: {
    label: 'general.filterDate.month',
    translate: true,
    name: 'month',
    type: 'filter-select',
    items: monthYear.map((e) => ({
      ...e,
      value: e.value + 1,
    })),
    value: null,
    size: {
      xl: 6,
      lg: 6,
      md: 6,
      sm: 6,
      xs: 6,
    },
  },
  from: {
    label: 'general.tags.from',
    translate: true,
    name: 'from',
    type: 'date',
    value: null,
    rest: {
      max: 'to',
    },
    size: {
      xl: 6,
      lg: 6,
      md: 6,
      sm: 6,
      xs: 6,
    },
  },
  to: {
    label: 'general.tags.to',
    translate: true,
    name: 'to',
    type: 'date',
    value: null,
    rest: {
      min: 'from',
    },
    size: {
      xl: 6,
      lg: 6,
      md: 6,
      sm: 6,
      xs: 6,
    },
  },
} as { [x: string]: InputModel }
